{
  "name": "rekor-cli",
  "version": "0.1.98",
  "type": "module",
  "engines": {
    "node": ">=20.0.0"
  },
  "bin": {
    "rekor": "dist/index.js"
  },
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "tsup",
    "typecheck": "tsc --noEmit",
    "test": "vitest run",
    "dev": "tsup --watch"
  },
  "dependencies": {
    "@napi-rs/keyring": "^1.1.6",
    "chalk": "^5.4.1",
    "cli-table3": "^0.6.5",
    "commander": "^14.0.0",
    "open": "^11.0.0",
    "yaml": "^2.9.0"
  },
  "optionalDependencies": {
    "@sentry/node": "^10.59.0"
  },
  "devDependencies": {
    "@types/node": "^25.5.0",
    "tsup": "^8.4.0",
    "typescript": "^5.8.2",
    "vitest": "^4.1.9"
  }
}
